import React from 'react';
import {HexagonCard} from '@learningblocks/storybook-components';
import {Feedback} from '../SharedComponents/Feedback';
import PropTypes from 'prop-types';
import './style.scss';

export function HexagonPathNode(props) {
  const getWrapper = () => {
    const {selected} = props.component;
    if (selected) {
      if (props.isCorrect) {
        return 'pathOption__correct';
      } else {
        return 'pathOption__incorrect';
      }
    } else {
      return 'pathOption';
    }
  };

  const onNodeClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    props.onNodeClick(props.component.id);
  };

  const renderFeedback = () => {
    if (props.component.selected) {
      return (
        <Feedback correct={props.isCorrect} message={props.feedbackMessage} />
      );
    } else {
      return null;
    }
  };

  return (
    <div className={getWrapper()} onClick={onNodeClick}>
      <HexagonCard {...props.component} />
      {renderFeedback()}
    </div>
  );
}

HexagonPathNode.propTypes = {
  /**
   * Function to invoke when path node is clicked
   */
  onNodeClick: PropTypes.func,
  /**
   * Boolean to check if selected option is correct
   */
  isCorrect: PropTypes.bool,
  /**
   * Error message to display on hovering incorrect icon
   */
  feedbackMessage: PropTypes.string,
  /**
   * All properties for rendering the HexagonNode
   */
  component: PropTypes.shape({
    /**
     * Unique ID for the component
     */
    id: PropTypes.number,
    /**
     * Image for the icon
     */
    image: PropTypes.string,
    /**
     * Title of the Card
     */
    title: PropTypes.string,
    /**
     * Boolean to specify if component is selected
     */
    selected: PropTypes.bool,
    /**
     * Attributes for displaying the modal window with card details
     */
    modal: PropTypes.object,
  }),
};

HexagonPathNode.defaultProps = {
  isCorrect: null,
  feedbackMessage: '',
  onNodeClick: undefined,
};
